import { getPartnerAccessToken } from '@leagueplatform/sso-util';

export async function getAccessToken(url: string, ubk: string) {
  const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'GET',

    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      ...(ubk && { brandUbk: ubk }),
    }),
  };
  try {
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export const formatDate = (dateString: any) => {
  const destructureDate = dateString.split('-');
  return `${destructureDate[1]}/${destructureDate[2]}/${destructureDate[0]}`;
};
